import axios from 'axios';
import { UploadFile } from 'antd';
import { RcFile } from 'antd/es/upload';

/// Upload content to GCS or any service that supports the same PUT API
export async function uploadGcs(
  chunks: ArrayBuffer[],
  url: string,
  progressCb?: (percent: number) => void,
): Promise<void> {
  const totalBytes = chunks.reduce((sum, chunk) => chunk.byteLength + sum, 0);
  let offset = 0;
  for (const chunk of chunks) {
    const response = await axios.put(url, chunk, {
      headers: {
        'Content-Type': 'application/octet-stream',
        'Content-Range': `bytes ${offset}-${chunk.byteLength - 1}/${totalBytes}`,
      },
      validateStatus: (status) => status >= 200 && status < 400,
      onUploadProgress: (progressEvent) => {
        if (progressCb && chunks.length === 1 && progressEvent.lengthComputable) {
          progressCb((progressEvent.loaded / progressEvent.total) * 100);
        }
      },
    });

    if (response.status === 308) {
      // Chunk successfully received.
      // TODO(rkjaran): Retry if not
      offset = parseInt(response.headers['range'].split('-')[1], 10);
    } else if (response.status === 200 || response.status === 201) {
      // TODO(rkjaran): Do something useful
      console.debug('Finished upload.');
      if (progressCb && chunks.length > 1) {
        progressCb(100);
      }
    }
  }
}

/// Map a normal JS File object to the UploadFile required for AntD's Upload component
export const mapFileToUploadFile = (file: File): UploadFile => {
  const uid = `rc-upload-${file.name}`;

  // Trust me bro ;)
  const tempFile = { ...file, uid } as unknown as RcFile;

  return {
    uid,
    name: file.name,
    originFileObj: tempFile,
    status: 'done',
  };
};
